import { animate, state, style, transition, trigger } from '@angular/animations'
import { ChangeDetectorRef, Compiler, Component, EventEmitter, Injector, Input, NgModuleRef, OnInit, Output, ViewChild } from '@angular/core'
import { MatCheckbox, MatPaginator, MatSort, MatTableDataSource, Sort } from '@angular/material'
import { DomSanitizer } from '@angular/platform-browser'
import { DialogService, DossierService, UtilitaryService } from '../../../services'
import { FormulaireService } from '../../../services'
import { FormDialogFormulaireWithSFComponent } from '../form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { LoadDialogComponent } from '../../../views/partials/layout/dialogs/load-dialog/load.component'
import { environment } from '../../../../environments/environment'

import { ContextMenu } from "../../../views/partials/layout/context-menu/icontextmenu.component"

/**
 * @title Basic use of `<table mat-table>`
 */
@Component({
	selector: 'table-atyl-display',
	styleUrls: ['./table-atyl-display.component.scss'],
	templateUrl: './table-atyl-display.component.html',
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})


export class TableAtylDisplayComponent implements OnInit {

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator

	@Input() removeRow: boolean = false;

	@Input() data: any[] = [];
	@Input() columns: any[] = [];
	@Input() inited = new EventEmitter<any>();

	@Input() displayedColumns = [];
	@ViewChild(MatSort, { static: false }) sort: MatSort

	@Input() length: number = 0;
	@Input() pageSize: number = 10;
	@Input() isPageSize: Boolean = true;
	pageSizeOptions: number[]= [5, 10, 15, 20,50,100];
	@Input() currentPage: number = 0;
	@Input() page: number = 0;
	@Input() hidePageSize:boolean= false;
	
	@Input() expanded: any[] = [];

	totalLength: number = 0;
	sortLoading: boolean = false;
	private _loading: boolean = false;
	@Input() set loading(value: boolean) {
		this._loading = value;
		if (!value) { this.sortLoading = false; }
	}
	get loading(): boolean { return this._loading; }

	@Output() loaded = new EventEmitter<boolean>();
	@Output() changePaged = new EventEmitter<any>();
	@Output() rowClicked = new EventEmitter<any>();
	@Output() cellClicked = new EventEmitter<any>();
	@Output() removeLine = new EventEmitter<any>();
	@Output() actionLine = new EventEmitter<any>();
	@Output() sortByColumn = new EventEmitter<any>();
	@Output() changeExpanded = new EventEmitter<any>();
	@Output() selectChanged = new EventEmitter<any>();
    @Output() checkInformations = new EventEmitter<any>();
    @Output() checkEmitter = new EventEmitter<any>();
    @Output() checkEmitterAll = new EventEmitter<any>();
	
	@Output() cellContextMenu = new EventEmitter<any>();
	@Input()  contextMenuItems: Array<ContextMenu> = [];
	@Input()  isDisplayContextMenu:boolean=false;
	@Output() contextMenuClicked = new EventEmitter<any>();
	rightClickMenuPositionX: number;
	rightClickMenuPositionY: number;
	
	@Input() action: boolean = false;
	@Input() allowChangeDisplayType: boolean = false;

	@Input() displayType: string = 'table';
	cardsPerRow: number = 3;
	cardsPerRowOptions: number[] = [1, 2, 3, 4, 6];

	get hasCardSectionConfig(): boolean {
		return this.columns.some(c => c.cardSection != null);
	}

	get cardHeaderColumns(): any[] {
		return this.columns
			.filter(c => c.visible && c.cardSection === 'header')
			.sort((a, b) => (a.cardOrder ?? 999) - (b.cardOrder ?? 999));
	}

	get cardTitleColumn(): any {
		const specials = ['selectable', 'action', 'Action', 'Remove', 'view', 'direction'];
		return this.columns.find(c => !specials.includes(c.id)) || null;
	}

	get cardBodyColumns(): any[] {
		const specials = ['selectable', 'action', 'Action', 'Remove', 'view', 'direction'];
		if (this.hasCardSectionConfig) {
			return this.columns.filter(c => c.visible && c.cardSection !== 'header' && !specials.includes(c.id));
		}
		return this.columns.filter(c => c.visible && !specials.includes(c.id));
	}

	get cardActionColumns(): any[] {
		return this.columns.filter(c => c.visible && ['action', 'Action', 'Remove', 'view'].includes(c.id));
	}

	get cardColorSourceColumn(): any {
		return this.columns.find(c => c.cardColorSource === true) || null;
	}

	get cardIconSourceColumn(): any {
		return this.columns.find(c => c.cardIconSource === true) || null;
	}

	getCardHeadStyle(element: any): any {
		const col = this.cardColorSourceColumn;
		if (!col || !element[col.id]) return null;
		const val = element[col.id] as string;
		const cssMatch = val.match(/color\s*:\s*(rgba?\([^)]+\)|#[0-9a-fA-F]+|[a-zA-Z]+)/i);
		if (cssMatch) return { 'background-color': cssMatch[1].trim() };
		const plainMatch = val.match(/^(rgba?\([^)]+\)|#[0-9a-fA-F]{3,8})$/i);
		return plainMatch ? { 'background-color': plainMatch[1].trim() } : null;
	}

	getCardHeadIcon(element: any): string | null {
		const col = this.cardIconSourceColumn;
		if (!col || !element[col.id]) return null;
		const val = element[col.id] as string;
		const htmlMatch = val.match(/<i[^>]+class=["']([^"']+)["']/i);
		if (htmlMatch) return htmlMatch[1].trim();
		return val.includes('<') ? null : val.trim();
	}

	get hasSelectableColumn(): boolean {
		return this.columns.some(c => c.visible && c.id === 'selectable');
	}

	get sortableColumns(): any[] {
		const specials = ['selectable', 'action', 'Action', 'Remove', 'view', 'direction'];
		return this.columns.filter(c => c.sortable && !specials.includes(c.id));
	}

	onCardSort() {
		if (this.sortActive) {
			this.sortLoading = true;
			this.sortData({ active: this.sortActive, direction: this.sortDirection } as Sort);
		}
	}

	exportableData: object = {};
	checkedOne: any[] = [];
	checkedAll: boolean = false;
	expandedElement: any
	dataSource = new MatTableDataSource();
	expandedPanel:boolean=true;
	
	sortActive:string=null;
	sortDirection:string="asc";
    nonTableau: any;

	@Input() showFirstLastButtons: boolean = true;
	@Input() IsSetting: boolean = true;
	
	constructor(
		private compiler: Compiler,
		private injector: Injector,
		private moduleRef: NgModuleRef<any>,
		private sanitizer: DomSanitizer,
		private cdf: ChangeDetectorRef,
		private utilities: UtilitaryService,
        private formulaireService: FormulaireService,
        private dossierService: DossierService,
        private dialogService: DialogService) {

	}

	ngOnInit() {
		this.loading = true
		if (!this.isPageSize)
			this.pageSizeOptions=[this.pageSize]
		if (this.paginator) {
			this.paginator._intl.itemsPerPageLabel = 'Nombre par page:'
			 this.paginator._intl.nextPageLabel = 'Page suivante';
             this.paginator._intl.previousPageLabel = 'Page précédente';
             this.paginator._intl.lastPageLabel = 'Dernière page';
             this.paginator._intl.firstPageLabel  = 'Première page';
             
			this.paginator._intl.getRangeLabel = (page, pageSize, length) => {
				if (length == 0 || pageSize == 0) {
					return `0 de ${length}`
				}
				length = Math.max(length, 0)
				if (this.hidePageSize && !this.showFirstLastButtons) 
				    return `${length} résultat(s)`;
				
				
				const startIndex = page * pageSize
				const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize
				return `${startIndex + 1} – ${endIndex} de ${length}`
			}
		}
		this._setDefaultSort();
		
		this.inited.subscribe(item => {
			this.onInited(item)
		})

		if (this.action) {
					let action:any={
						id: "action",
						label: "",
						sortable: false,
						icon: "la la-caret-down",
						visible: true
					}
					this.columns.push(action);
					
		}
		
		
		this.exportableData = {}
		this.selectChanged.emit(this.exportableData);
	}

	ngOnChanges(changes: any) {
		//console.log("TableAtylDisplayComponent change",changes)
		if (changes.data && changes.data.currentValue)
			this.createTable()
	}
	ngAfterViewInit() {
		this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.id)
		if (this.data)
			this.createTable()
		this.loaded.emit(true)

		this.exportableData = {}
		this.selectChanged.emit(this.exportableData);
	}

	_setDefaultSort() {
		for(let i=0;i<this.columns.length;i++) {
			let cl:any=this.columns[i];
			if (this.sortActive==null && cl.defaultSort!=undefined && cl.defaultSort!==null ) {
				this.sortActive=cl.id;
				this.sortDirection=cl.defaultSort.toLowerCase();
		//		console.log("TableAtylDisplayComponent _setDefaultSort",cl,this.sortActive,this.sortDirection)
			} 
		}

		this.exportableData = {}
		this.selectChanged.emit(this.exportableData);
	}

	createTable() {
		this.dataSource.data = this.data
		this.page = this.currentPage
		
		if (this.data)
			for(let i=0;i<this.data.length;i++) {
				const row = this.data[i]

				this.checkedOne[row.id]=false;
                if(this.data[i].checked){
					this.exportableData[row.id] = row
				    this.checkedOne[row.id]=true;  
                }else{
					delete(this.exportableData[row.id]);
				    this.checkedOne[row.id]=false;  
                }     

			}

		this.loading = false
		this.exportableData = {}
		this.selectChanged.emit(this.exportableData);
		//this.totalLength = 0;
		//this.totalLength = this.length;
	}

	addColmunn(id, title) {
		let column: any = {
			'id': id,
			'title': title
		}
		this.columns.push(column)
	}

	onRowClicked(row) {
		this.expandedElement = this.expandedElement === row ? null : row
		this.rowClicked.emit(row)
	}

	onInited(item) {
		// this.displayedColumns = this.columns.map(x => x.id);
		setTimeout(() => {
			this.createTable()
		})
	}

	setDirection() {

	}
	sortData(sort: Sort) {
		this.loading = true;
		this.sortActive = sort.active;
		this.sortDirection = (sort.direction as string) || 'asc';
		this.sortByColumn.emit(sort);

		this.exportableData = {};
		this.selectChanged.emit(this.exportableData);
	}

	public handlePage(e: any) {
		//this.currentPage = e.pageIndex;
		//this.pageSize = e.pageSize;
		//	this.dataSource.data=[];
		this.totalLength = 0
		let pagination: any = {
			currentPage: e.pageIndex,
			pageSize: e.pageSize
		}
		//console.log("pagination",e,pagination);
		this.changePaged.emit(pagination)

		this.exportableData = {}
		this.selectChanged.emit(this.exportableData);

		this.checkedAll = false
		const checkboxAll = document.querySelector<HTMLInputElement>("#checkboxselectable_all");
		if (checkboxAll) checkboxAll.checked = false
		
	}

	openIframe(url) 
	{
		if (url) {
			this.dialogService.open(LoadDialogComponent, {
				data: {
					url: "/client/dist" + url,
					urlParameters: {
						tokenAtyl: environment.tokenauth,
						isCropped: "true",
					}
				},
				height: "95vh",
				width: "80%",
				minimizable: true,
				maximizable: true,
				draggable: true,
			}, (res: any) => {
			})
		}
	}

	removeLineClicked(cell: any) {
		this.removeLine.emit(cell)
	}
	
	
	actionLineClicked(cell: any) {
		this.actionLine.emit(cell)
	}
	
	onCellClicked(row: any,column:any,event:any) {
		//console.log("onCellClicked",row,column);
		if (column.id != 'selectable') {
			let elt={
	            column: column,
	            row: row,
				event: event,
	        };
	
	        this.cellClicked.emit(elt)
		} else
			event.stopPropagation();
    }
	
	
    
    onSelectableClicked(row:any,event:any) {
		event.stopPropagation();

		if (row["id"]!=undefined) {
			if (this.exportableData[row.id]!=undefined) {
				delete(this.exportableData[row.id]);
				this.checkedOne[row.id]=false;
	        }
	        else {
				this.exportableData[row.id]=row;
				this.checkedOne[row.id]=true;
			}
	    //    console.log("checkedOne",this.checkedOne);
		//	console.log("exportableData",this.exportableData);

		}
        this.checkEmitter.emit({"id": row.id,"value":event.target.checked});
        this.checkInformations.emit(row);
		this.selectChanged.emit(this.exportableData);
	}
	
	onSelectableChanged(row,event) {
		event.stopPropagation();
		//console.log("checkedOne",this.checkedOne);
		if (row["id"]!=undefined) {
			if (this.exportableData[row.id]!=undefined) {
				delete(this.exportableData[row.id]);
				this.checkedOne[row.id]=false;
	        }
	        else {
				this.exportableData[row.id]=row;
				this.checkedOne[row.id]=true;
			}
	        //console.log("checkedOne",this.checkedOne);
			console.log("exportableData",this.exportableData);
		}
 
		this.selectChanged.emit(this.exportableData);
	}
	
	
	onSelectableAllClicked() {
		//event.stopPropagation();
		console.log("onSelectableAllClicked",this.checkedAll);
		if (this.data) {
			for(let i=0;i<this.data.length;i++) {
				let checkbox:HTMLInputElement = document.querySelector<HTMLInputElement>("#checkboxselectable_"+this.data[i].id);
				if (this.checkedAll) {
					this.exportableData[this.data[i].id]=this.data[i];
				} else {
					if (this.exportableData[this.data[i].id]!=undefined) {
						delete(this.exportableData[this.data[i].id]);
				
					}
				}
				if (this.data[i].id!=undefined && this.checkedOne[this.data[i].id]!=undefined )
					this.checkedOne[this.data[i].id]=this.checkedAll;
				if (checkbox)
					checkbox.checked=this.checkedAll;
				console.log("onSelectableAllClicked checkbox",checkbox);
			}
			this.selectChanged.emit(this.exportableData);
            let _opt = [];
            this.data.forEach((res,index) =>{
                _opt[index] = {"id": res.id, "value": this.checkedAll}
            });
            this.checkEmitterAll.emit(_opt);
		}
	}

	
	
    /*handleClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const onclick = target.getAttribute('function');
        console.log("Cell function",onclick)
        if (onclick == 'openForm') {
            const idForm = target.getAttribute('formid');
            if(idForm){
                event.stopPropagation();
                this.openForm(idForm);
            }
        }
		if (onclick == 'unactiveEvent()') {
		          
		               event.stopPropagation();
		             
		           
		  }
		  if (onclick == 'copy()') {
		  		          
		  		               event.stopPropagation();
						try {
							   						
							  this._copy(target.innerText)
							   								
							   								
					} catch (err) {
					}			   
		  		             
		  		           
		   }
		
		const toggleRef = /toggleDiv\(\'(.*)\'\)/;
		if (onclick!=undefined && onclick) {
				const matches = onclick.match(toggleRef);
				if (matches && Array.isArray(matches) && matches.length>0 ) {
				        
					let div:HTMLElement=document.getElementById(matches[1]);
				      if(div){
						  event.stopPropagation();	
					      let myclass:any=div.getAttribute("class");
						  if (myclass && myclass=="d-none")
							div.removeAttribute("class");
						else
							div.setAttribute("class","d-none");
						
							try {
								
							          this._copy(div.innerText)
										
										
								} catch (err) {
								        console.log('Was not possible to copy te text: ', err);
							}	
				      }    
						               
			    }
			}
	    }
*/
	handleClick(event: MouseEvent) {
		   const target = event.target as HTMLElement;
		   const onclick = target.getAttribute('data-function');
		   console.log("Cell function",onclick)
		   if (onclick == 'openForm') {
		       const idForm = target.getAttribute('formid');
		       if(idForm){
		           event.stopPropagation();
		           this.openForm(idForm);
		       }
		   }
		if (onclick == 'unactiveEvent()') {
		          
		               event.stopPropagation();
		             
		           
		  }
		  if (onclick == 'copy()') {
		  		          
		  		               event.stopPropagation();
						try {
							   						
							  this._copy(target.innerText)
							   								
							   								
					} catch (err) {
					}			   
		  		             
		  		           
		   }
		
		const toggleRef = /toggleDiv\(\'(.*)\'\)/;
		if (onclick!=undefined && onclick) {
		const matches = onclick.match(toggleRef);
		if (matches && Array.isArray(matches) && matches.length>0 ) {
		        
			let div:HTMLElement=document.getElementById(matches[1]);
		      if(div){
				  event.stopPropagation();	
			      let myclass:any=div.getAttribute("class");
				  console.log("Cell function",myclass,div,div.classList)
				  if (myclass && myclass.includes("d-none"))
					div.classList.remove("d-none");
					//div.removeAttribute("class");
				else
					div.classList.add("d-none");
					//div.setAttribute("class","d-none");
				
					try {
						
					          this._copy(div.innerText)
								
								
						} catch (err) {
						        console.log('Was not possible to copy te text: ', err);
					}	
		      }    
				               
	    }
	}
	}


	_copy(text: string) {
	  if (navigator.clipboard) {
	    navigator.clipboard.writeText(text)
	  } else {
	    const input = document.createElement('textarea')
	    input.value = text
	    document.body.appendChild(input)
	    input.select()
	    document.execCommand('copy')
	    document.body.removeChild(input)
	  }
	}

    openForm(idForm: string){
        
        var options = {
            childView:true
        };
        this.formulaireService.get(idForm,options).subscribe(res=>{
            if(res && res.result){
                this.popupFormulaire(res.result);
            }
        })
    }

    popupFormulaire(formulaire: any) {
		console.log("PopupForm",formulaire)
		let form = formulaire.form
        let dossierId = formulaire.demande.dossier.ID
        if(dossierId){
            this.dossierService.get(dossierId).subscribe(res=>{
                if(res && res.result){
                    const dossier = res.result;
                    if (form && form.under_form && form.under_form.length === 0) {
                        let datasF = {
                                title: form.libelle,
                                id: formulaire.ID,
                                formType: form.key,
                                idDemandeForm: form.ID,
                                
                            }
                       datasF['dossier'] = dossier
                       datasF['isEditable'] = false;
                       /*
                       datasF['isEditable'] = true;
                       if (formulaire.isEditable!=undefined)
                           datasF['isEditable'] = formulaire.isEditable;*/
                          
                        if (formulaire.instruction)
                             datasF['instruction'] = formulaire.instruction
                        console.log("popupFormulaire FormDialogFormulaireWithSFComponent",datasF,formulaire)     
                        this.dialogService.open(FormDialogFormulaireWithSFComponent, {
                            data: datasF,
                            height: '90vh',
                            width: "90vw",
                            resizable: true,
                            minimizable: true,
                            draggable: true,
                            maximizable: true,
                        }, (result: any) => {
                        })
                    }
                    else if (form && form.under_form && form.under_form.length > 0) {
                        let form = formulaire.form
                        let datasF = {
                            title: form.libelle,
                            id: formulaire.ID,
                            formType: form.key,
                            idDemandeForm: form.ID,
                        }
                        datasF['dossier'] = dossier
                        datasF['isEditable'] = false;
                        /*
                        datasF['isEditable'] = true;
                        if (formulaire.isEditable!=undefined)
                           datasF['isEditable'] = formulaire.isEditable;*/
                        this.dialogService.open(FormDialogFormulaireWithSFComponent, {
                            data: datasF,
                            height: '90vh',
                            width: "90vw",
                            resizable: true,
                            minimizable: true,
                            draggable: true,
                            maximizable: true,
                        })
                    }

                }
            })
        }
		
	}
	
	displayAction(action:any) {
			let ac:string[]=[];
			Object.keys(action).forEach(function (key) {
			    var val = action[key];
			    if (val!==undefined && val && val.length>0)
			       ac.push(val);
			});
			return 	ac.join("<br/>");	
	}
	
	getDisplayedColumns(): string[] {
		    return this.columns.filter(x => x.visible).map(x => x.id);
	}
	
	onCellContextMenu(event:any,row: any,column:any) {
			console.log("onCellContextMenu",row,column);
			event.stopPropagation();
			if (column.id != 'selectable') {
				let elt={
		            column: column,
		            row: row,
		            event: event,
		        };
				
				//this.rightClickMenuPositionX=event.clientX -(event.screenY-  event.pageY) ;
				this.rightClickMenuPositionX=(event.pageX -  event.clientX) ;
				this.rightClickMenuPositionY=(event.pageY- event.clientY); //event.clientY -(event.screenY-  event.pageY)  ;
				//this.rightClickMenuPositionY=(event.screenY-  event.pageY)  ;
								
		        this.cellContextMenu.emit(elt);
				return false;
			} else
				event.stopPropagation();
		    return true;
		}
	
	handleMenuItemClick(event:any) {
		console.log("handleMenuItemClick",event);
		this.contextMenuClicked.emit(event);
	}
	
	getRightClickMenuStyle() {
		return {
			"margin-bottom": "1px",
			"margin-left": "1px",
			/*position: 'absolute',
			left: `${this.rightClickMenuPositionX}px`,
			top: `${this.rightClickMenuPositionY}px`*/
			
		};
	}
	
	getColCard() {
		let nxCol:number=12;
		/*let col:string="col-4";
		//		cardsPerRowOptions: number[] = [1, 2, 3, 4, 6];
		switch(this.cardsPerRow) {
			case 1:
				col="col-12";break;
			case 2:
				col="col-6";break;	
			case 4:
				col="col-3";break;
			case 6:
				col="col-2";break;				
		}
		*/
		let col:string="col-4";
		if (this.cardsPerRow>0)
			col="col-"+(nxCol/this.cardsPerRow);
		
		return col;
	}
    
}